import { useSetAtom } from 'jotai';
import React, { useCallback, useMemo } from 'react';

import { ReceiveOption } from '~/components/partials/ReceiveOption';
import {
  KarteAppointmentFragment,
  ReceptionPaneAppointmentFragment,
} from '~/graphql/generated/graphql';
import { changeDeliveryMethodState } from '~/state/partials/change_delivery_method_modal/atoms';

type Props = {
  appointment: KarteAppointmentFragment | ReceptionPaneAppointmentFragment;
  children?: React.ReactNode;
};

export const ReceiveOptionChangeableBlock = (props: Props) => {
  const { appointment, children } = props;
  const deliveryMethod = appointment.deliveryMethod;
  const telemedicine = appointment.telemedicine;
  const appointmentStatus = appointment.status;
  const setChangeDeliveryMethodModal = useSetAtom(changeDeliveryMethodState);
  const onClick = useCallback(() => {
    setChangeDeliveryMethodModal({
      isOpen: true,
      appointmentId: appointment.id,
    });
  }, [appointment.id, setChangeDeliveryMethodModal]);

  const handleClick = useMemo(() => {
    if (!telemedicine) {
      return undefined;
    }

    if (
      appointmentStatus === 'finished' ||
      appointmentStatus === 'cancelled' ||
      appointmentStatus === 'noshow' ||
      appointmentStatus === 'charged'
    ) {
      return undefined;
    }

    const uberDelivery = appointment.uberDelivery;
    if (
      uberDelivery &&
      (uberDelivery.status === 'pickup' ||
        uberDelivery.status === 'dropoff' ||
        uberDelivery.status === 'delivered' ||
        uberDelivery.status === 'canceled' ||
        uberDelivery.status === 'return_delivered' ||
        uberDelivery.status === 'uber_support_canceled')
    ) {
      return undefined;
    }

    return onClick;
  }, [appointment.uberDelivery, appointmentStatus, onClick, telemedicine]);

  return (
    <ReceiveOption deliveryMethod={deliveryMethod} onClick={handleClick}>
      {children}
    </ReceiveOption>
  );
};
